import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { formatNumber } from "../../utils";

/** Which write is in flight; every button waits for it. */
export type DayWrite = "DRAFT" | "SUBMIT" | "NO_EXPENSE";

interface DayFormFooterProps {
  salesTotal: number;
  adminTotal: number;
  total: number;
  /** The buttons exist only while the branch may still change the day. */
  canEdit: boolean;
  pendingWrite: DayWrite | null;
  onNoExpense: () => void;
  onSaveDraft: () => void;
  onSubmit: () => void;
}

/** The form's pinned bottom bar: the three totals, and บันทึกร่าง / ส่งให้ HO / ไม่มีค่าใช้จ่ายวันนี้. */
export default function DayFormFooter({
  salesTotal,
  adminTotal,
  total,
  canEdit,
  pendingWrite,
  onNoExpense,
  onSaveDraft,
  onSubmit,
}: Readonly<DayFormFooterProps>) {
  const isBusy = pendingWrite !== null;

  return (
    <Paper
      elevation={3}
      sx={{ position: "sticky", bottom: 0, zIndex: (theme) => theme.zIndex.appBar }}
    >
      <Stack direction="row" alignItems="center" gap={3} flexWrap="wrap">
        <Stack
          direction="row"
          alignItems="baseline"
          gap={2.5}
          flexWrap="wrap"
          sx={{ flex: 1, fontVariantNumeric: "tabular-nums", color: "text.secondary" }}
        >
          <Typography variant="body2">
            ฝ่ายขาย{" "}
            <Box component="span" sx={{ color: "text.primary", fontWeight: 600 }}>
              {formatNumber(salesTotal)}
            </Box>
          </Typography>
          <Typography variant="body2">
            ฝ่ายบริหาร{" "}
            <Box component="span" sx={{ color: "text.primary", fontWeight: 600 }}>
              {formatNumber(adminTotal)}
            </Box>
          </Typography>
          <Typography variant="body2">
            รวมทั้งหมด{" "}
            <Box component="span" sx={{ color: "text.primary", fontWeight: 700, fontSize: "1.125rem" }}>
              {formatNumber(total)}
            </Box>{" "}
            บาท
          </Typography>
        </Stack>
        {canEdit && (
          <Stack direction="row" alignItems="center" gap={1}>
            <Button
              color="inherit"
              onClick={onNoExpense}
              disabled={isBusy}
              loading={pendingWrite === "NO_EXPENSE"}
            >
              ไม่มีค่าใช้จ่ายวันนี้
            </Button>
            <Button
              variant="outlined"
              onClick={onSaveDraft}
              disabled={isBusy}
              loading={pendingWrite === "DRAFT"}
            >
              บันทึกร่าง
            </Button>
            <Button
              variant="contained"
              onClick={onSubmit}
              disabled={isBusy}
              loading={pendingWrite === "SUBMIT"}
            >
              ส่งให้ HO
            </Button>
          </Stack>
        )}
      </Stack>
    </Paper>
  );
}
